var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8",
    stroke: "#0A0A0A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6721 1.39941C11.9278 1.14367 12.2747 1 12.6363 1C12.998 1 13.3448 1.14367 13.6006 1.39941C13.8563 1.65515 14 2.00201 14 2.36367C14 2.72534 13.8563 3.0722 13.6006 3.32794L7.80665 9.12252C7.65401 9.27503 7.46543 9.38667 7.25831 9.44715L5.41142 9.98714C5.3561 10.0033 5.29747 10.0042 5.24165 9.98994C5.18583 9.97564 5.13489 9.9466 5.09414 9.90586C5.0534 9.86511 5.02436 9.81417 5.01006 9.75835C4.99576 9.70253 4.99672 9.6439 5.01286 9.58858L5.55284 7.74169C5.61361 7.53473 5.72547 7.34638 5.87812 7.19399L11.6721 1.39941Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.09c936d6f089ded1c2858cd5196b4d92.svg";
export { ForwardRef as ReactComponent };